module.exports = ".wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.panel-body {\n  vertical-align: middle;\n  text-align: center; }\n\n.panel-body > div {\n    padding: 8px; }\n\n.msg {\n  font-size: 1.6em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/verify-email/verify-email.component.scss
// module id = ./src/app/verify-email/verify-email.component.scss
// module chunks = main